import React from "react";
import styles from "./YourAssets.module.scss";

export default function YourAssets({handleActive,activeIndex}) {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {Array.from(Array(6), (e, i) => {
          return (
            <div
              className={`${styles.tableWrapper} ${
                activeIndex === i && styles.active
              }`}
              key={i}
              onClick={()=>handleActive(i)}
            >
              <div className={styles.assetBasics}>
                <img
                  src={"/assets/dots.svg"}
                  width="12px"
                  height="20px"
                  alt="Picture of the author"
                />
                <div className={styles.flexcolumn}>
                  <img
                    src={"/assets/bitcoin-btc-logo.svg"}
                    width="40px"
                    height="40px"
                    alt="Picture of the author"
                  />
                  <div className={styles.coinName}>Bitcoin</div>
                  <div className={styles.coinSymble}>BTC</div>
                </div>
                <div className={styles.seprator}></div>
              </div>
              <div className={styles.flexCol}>
                <div className={styles.text}>PRICE</div>
                <div className={styles.price}>$7,296.46</div>
              </div>
              <div className={styles.flexCol}>
                <div className={styles.text}>24H CHANGE</div>
                <div className={styles.change}>+0.35%</div>
              </div>
              <div className={styles.flexCol}>
                <div className={styles.text}>YOUR BALANCE</div>
                <div className={styles.your}>0.0819132 BTC</div>
              </div>
              <div className={styles.flexCol}>
                <div className={styles.text}>VALUE</div>
                <div className={styles.price}>$651.49</div>
              </div>
              <div className={styles.flexCol}>
                <div className={styles.text}>PORTFOLIO </div>
                <div className={styles.price}>26.45%</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
